import React, { Component } from 'react';

class NoMatch extends Component {
  render() {
    return (
      <div>
        <h1>404</h1>
      </div>
    );
  }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch.js